import { configureStore } from "@reduxjs/toolkit";
import auth from "./Slices/Auth";
import user from "./Slices/User";
import breadcrumb from "./Slices/BreadCrumb";
import concept from "./Slices/Concept";
import common from "./Slices/Common";

export const store = configureStore({
  reducer: {
    auth,
    user,
    breadcrumb,
    conceptState: concept,
    commonState: common,
  },
});
